export const errorConstants = {
    SET_ERROR: "SET_ERROR",
    HIDE_ERROR: "HIDE_ERROR"
};
